import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.3125 2.8125H1.875C1.3125 2.8125 0.9375 3.1875 0.9375 3.75V14.0625C0.9375 14.625 1.3125 15 1.875 15H10.3125C10.875 15 11.25 14.625 11.25 14.0625V3.75C11.25 3.1875 10.875 2.8125 10.3125 2.8125ZM9.375 10.3125H2.8125V4.6875H9.375V10.3125Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.0625 12.1875H12.1875V1.875H3.75V0H13.125C13.6875 0 14.0625 0.375 14.0625 0.9375V12.1875Z",
		fill: "currentColor"
	})]
});
export default SvgIconProject;
